import React, { useEffect, useState } from "react";
import { Footer, NavItem, NavMenu, ToggleButton } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftStyle, ArrowRightStyle, Container, Info, MainImage, ModelButton, SubtitleItalo, Thumbnail, Thumbnails, TitleItalo } from "../../Trajes/Negros/styles";
import { HiArrowLongLeft, HiArrowLongRight } from "react-icons/hi2";

const Londres = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    const enviarWhatsApp = (modelo) => {
        const numero = "5213311407070";
        const mensaje = `Hola, me interesa el modelo *${modelo}*, que vi en su página. ¿Podrías darme información sobre disponibilidad y precio?`;
        const url = `https://wa.me/${numero}?text=/${mensaje}`;

        window.open(url, "_blank");
    }

    const londres = [
        "/img/Londres.jpg",
        "/img/Londres-f.jpg",
        "/img/Londres-l.jpg",
        "/img/Londres-pr.jpg",
        "/img/Londres-pru.jpg",
        "/img/Londres-b.jpg",
        "/img/Londres-bup.jpg",
        "/img/Londres-dr.jpg",
        "/img/Londres-up.jpg",
    ]

    const [currentIndex, setCurrentIndex] = useState(0);
                                
    const nextImage = () => {
        setCurrentIndex((prev) => (prev + 1) % londres.length);
    };
                                                    
    const prevImage = () => {
        setCurrentIndex((prev) => (prev -1 + londres.length) % londres.length);
    };
                                                    
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
                                                  
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };
                                                   
    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };
                                                   
    const handleTouchEnd = () => {
        if (touchStart - touchEnd > 50) nextImage();
        if (touchEnd - touchStart > 50) prevImage();
    };

    return (
        <>
            <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? "✕" : "☰"}
            </ToggleButton>
            <NavMenu collapsed={collapsed}>
                <NavItem
                    active = {location.pathname === "/"}
                    onClick={() => navigate("/")}
                >
                    Inicio
                </NavItem>

                <NavItem
                    active = {location.pathname === "/trajes"}
                    onClick={() => navigate("/trajes")}
                >
                    Trajes
                </NavItem>

                <NavItem
                    active = {location.pathname.startsWith("/smokings")}
                    onClick={() => navigate("/smokings")}
                >
                    Smokings
                </NavItem>

                <NavItem
                    active = {location.pathname === "/togas"}
                    onClick={() => navigate("/togas")}
                >
                    Togas
                </NavItem>
                <NavItem>
                    <a
                        href="/catalogo-trajes"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Catálogo
                    </a>
                </NavItem>
                <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
            </NavMenu>
            <Container>

                <div style={{ position: 'relative'}}>
                    <ArrowLeftStyle onClick={prevImage}>
                        <HiArrowLongLeft size={20}/>
                    </ArrowLeftStyle>
                    <MainImage 
                        src={londres[currentIndex]} 
                        alt="Londres"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                    />
                    <ArrowRightStyle onClick={nextImage}>
                        <HiArrowLongRight size={20}/>
                    </ArrowRightStyle>
                </div>

                <Thumbnails>
                    {londres.map((img, index) => (
                        <Thumbnail 
                            key={index}
                            src={img}
                            alt="Thumbnail"
                            onClick={() => setCurrentIndex(index)}
                            active = {currentIndex === index}
                        />
                    ))}
                </Thumbnails>
                <Info>
                    <TitleItalo>Londres</TitleItalo>
                    <SubtitleItalo>
                        Ideal para eventos de gala y ocasiones donde la 
                        elegancia se expresa con un estilo diferente.
                        Un smoking en tono gris con solapa de punta 
                        y diseño ojo de perdiz que aporta profundidad 
                        y sofisticación, logrando una presencia distinguida y moderna.
                    </SubtitleItalo>
                    <ModelButton onClick={() => enviarWhatsApp("Londres")}>Cotizar</ModelButton>
                </Info>
            </Container>

            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
        </>
    )
};

export default Londres;